import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomButton from '../common/button';
import { Profile360_icon } from '../common/icons';
import CustomToolTip from '../common/tooltip';
import { profile360Selector, profile360_actions } from '../js/slice';
import { getRouteAccess } from '../../../utils/access-utils';

function DisclosureContent({
  tooltip = "",
  data = {},
  removeBtn = false,
  rightChild = <></>,
  ...props
}) {
  const dispatch = useDispatch();
  const reservationDetails = useSelector(profile360Selector.reservationDetails);
  const { write: isEditPermission } = getRouteAccess('profile-360');

  // disable button by reservation status -->>
  let disable = data.isDone || !isEditPermission;
  if (data.type == 'roomUpgrade') {
    if (reservationDetails.data.inforStatus != 'Reserved') {
      disable = true;
    }
  } else if (data.serviceType == 'chamomileTeaService') {
    if (reservationDetails.data.inforStatus != 'In-house') {
      disable = true;
    }
  } else if (
    reservationDetails.data.inforStatus != "Reserved" &&
    reservationDetails.data.inforStatus != "In-house"
  ) {
    disable = true;
  }
  // disable button by reservation status <<--

  return (
    <div className="drop-content flex items-center gap-4px justify-between mb-16px">
      <div className="child flex gap-4px items-center">
        {/* <div className="flex items-center">
         
        </div> */}
        <div className="drop-label flex items-start gap-4px">
          <Profile360_icon.radio2 success={data?.isDone} />
          <div>{data.title}</div>
        </div>
        {data.tooltip && (
          <CustomToolTip tooltipChild={data.tooltip}>
            <div className="flex items-center cursor-pointer">
              <Profile360_icon.tooltip />
            </div>
          </CustomToolTip>
        )}
      </div>

      {removeBtn ? (
        rightChild
      ) : (
        <CustomButton
          disabled={disable}
          onClick={() => isEditPermission
            && dispatch(
              profile360_actions.openModal({
                isFor: 'purposeful-engagement',
                title: data.modalTitle || data.title,
                data,
              }),
            )
          }
          style={{
            textTransform: 'uppercase',
            cursor: disable ? 'not-allowed' : 'pointer',
            opacity: disable ? 0.5 : 1,
          }}
          label={data?.buttonLabel}
        />
      )}
    </div>
  );
}

export default DisclosureContent;
